import { ReactComponent as BikeIcon } from "../assets/icons/dash/bike.svg";
import { ReactComponent as BusIcon } from "../assets/icons/dash/bus.svg";
import { ReactComponent as CarIcon } from "../assets/icons/dash/car.svg";
import { ReactComponent as TriIcon } from "../assets/icons/dash/tri.svg";
import { ReactComponent as TruckIcon } from "../assets/icons/dash/truck.svg";

export const statsIconConfig = {
  motorcycle: {
    icon: <CarIcon className="h-[31.7px] w-[31.7px]" />,
    iconClassName: "bg-[#EDF2DFB2]",
    label: "Motorcycle Drivers",
  },
  car: {
    icon: <BusIcon className="h-[31.7px] w-[31.7px]" />,
    iconClassName: "bg-[#E8BB001A]",
    label: "Car Drivers",
  },
  bus: {
    icon: <TruckIcon className="h-[31.7px] w-[31.7px]" />,
    iconClassName: "bg-[#0593481A]",
    label: "Bus Drivers",
  },
  bicycle: {
    icon: <BikeIcon className="h-[31.7px] w-[31.7px]" />,
    iconClassName: "bg-[#FB37481A]",
    label: "Bicycle Drivers",
  },
  truck: {
    icon: <TriIcon className="h-[31.7px] w-[31.7px]" />,
    iconClassName: "bg-[#990E7A1A]",
    label: "Truck Drivers",
  },
  tricycle: {
    icon: <TriIcon className="h-[31.7px] w-[31.7px]" />,
    iconClassName: "bg-[#990E7A1A]",
    label: "Tricycle Drivers",
  },
} as const;
